import { createAction } from 'redux-starter-kit';

/**
 * An action creator for replacing all tax-rates in the state
 * @param {object[]} taxRates An array of all the tax rates.
 * @example dispatch(putTaxRates(taxRates))
 */
export const putTaxRates = createAction('PUT_TAX_RATES');

/**
 * An action creator for putting a single tax-rate into the state.
 * @param {object} taxRate A single tax rate.
 * @example dispatch(putTaxRate(taxRate))
 */
export const putTaxRate = createAction('PUT_TAX_RATE');

/**
 * An action creator for removing a single tax-rate from the state.
 * @param {object} taxRateUnixTime The unix time for the taxRate
 * @example dispatch(removeTaxRate(new Date(taxRate.dateFrom).getTime()))
 */
export const removeTaxRate = createAction('REMOVE_TAX_RATE');
